import styled from "styled-components";
import {TextField} from "@mui/material";

export const StyledSelect = styled(TextField)`
`;
